import styled from 'styled-components'
import { RopFormWrap } from 'src/styles/styledcomponent/views/RopForm/RopForm'
import PageCalling from 'src/components/common/PageCalling'
import { useParams } from 'react-router-dom'
import { PramsKeys } from 'src/types/type'
import useAPI from 'src/hooks/useAPI'
import { useRecoilState, useSetRecoilState } from 'recoil'
import {
  PartnerListData,
  TelTypeState,
  TermsListData,
  authKeyState,
  uiData,
} from 'src/recoil/common'
import useMoveScroll from 'src/hooks/useMoveScroll'
import { useEffect } from 'react'
import Banner from 'src/components/common/Banner'
import MVNOModal from 'src/components/common/MVNOModal'
import useIsImgLoad from 'src/hooks/useIsImgLoad'
import PhoneVerification from 'src/components/views/Rop01/PhoneVerification'
import Terms from 'src/components/views/Rop01/Terms'
import JoinSubmit from 'src/components/views/Rop01/JoinSubmit'
import Footer from 'src/components/views/Rop01/Footer'
import useSubmit from 'src/hooks/useSubmit'
import { convertTermsData } from 'src/service/join'
import {useTrackingPage} from "src/hooks/useTrackingPage";
import {landing_greenp} from "src/service/utils/greenp";
import VulnerableCheckModal from 'src/components/common/VulnerableCheckModal'

const Rop01Wrap = styled(RopFormWrap)``

const Rop01 = () => {
  const { pcode, authKey, telecom } = useParams<PramsKeys>()
  const submit = useSubmit(pcode ?? '')
  const termsApi = useAPI('requestTermsList')

  const setTermsListData = useSetRecoilState(TermsListData)
  const setPartnerData = useSetRecoilState(PartnerListData)
  const setTelType = useSetRecoilState(TelTypeState)
  const setAuthKey = useSetRecoilState(authKeyState)
  const [
    {
      layoutsInsert: { mainBg },
    },
    setUiData,
  ] = useRecoilState(uiData)

  const {
    data: getTermsData,
    isSuccess,
    isLoading: getLoading,
  } = termsApi?.useSetQuery({ PCode: pcode })

  // 2024-06-26 이미지 로딩 작업
  const { isImgLoad, banner1Ref, banner2Ref } = useIsImgLoad(isSuccess)
  const { onMoveToElement, RefInput } = useMoveScroll(banner2Ref)
  const { form, isGreenpTracking } = useTrackingPage()

  //Greenp 추적 스크립트 추가(251217)
  useEffect(() => {
    if (!isGreenpTracking) return
    if ((window as any).__GREENP_LANDING_INIT__) return
      ;(window as any).__GREENP_LANDING_INIT__ = true
    landing_greenp()
  }, [form, isGreenpTracking])

  const checkImgLoad = () => {
    if (pcode !== 'cokbank_01') return true
    else if (pcode === 'cokbank_01' && isImgLoad) return true
    else return false
  }

  const isErrorPartner = getTermsData?.Header.ErrCode === 1011

  useEffect(() => {
    if (isSuccess && !isErrorPartner) {
      const data = getTermsData?.Body
      setTelType(Number(telecom))
      setTermsListData(convertTermsData(data))
      setPartnerData(data?.Partner)
      setUiData(JSON.parse(atob(data?.Partner.UiData)))
    }
    // eslint-disable-next-line
  }, [isSuccess, isErrorPartner, getTermsData?.Body, setPartnerData, setTermsListData, setTelType, setUiData])

  useEffect(() => {
    if (isSuccess) {
      if (pcode === 'pinc_01') {
        setAuthKey(authKey)
      }
    }
  }, [isSuccess, authKey, pcode, setAuthKey])

  return (
    <Rop01Wrap mainBg={mainBg}>
      <PageCalling active={getLoading || !checkImgLoad()} />
      {isSuccess && (
        <>
          <Banner banner1Ref={banner1Ref} banner2Ref={banner2Ref} />
          {checkImgLoad() && (
            <>
              <PhoneVerification
                onMoveToElement={onMoveToElement}
                RefInput={RefInput}
                submit={submit}
              />
              { !isErrorPartner && <Terms /> }
              <JoinSubmit submit={submit} />
              <Footer />
            </>
          )}
        </>
      )}

      {submit.isOpen && <MVNOModal submit={submit} />}
      {submit.vulnerableModal.isOpen && <VulnerableCheckModal submit={submit} />}
    </Rop01Wrap>
  )
}
export default Rop01
